// src/api/productDetailApi.js
import { PRODUCT_DETAIL_URL } from "../config/apiConfig";
// Commerce API POST /product_detail (2026-10-20; was the Cloud Function
// general_detail_page): same { product_id, visitor_id } body, same
// { product, variants } reply, plus similar_products.
const API_URL = PRODUCT_DETAIL_URL;

/** Sizes as the pages want them: a non-empty array of strings, else null. */
function sizeListOf(value) {
  if (Array.isArray(value)) {
    const list = value.map((s) => String(s ?? "").trim()).filter(Boolean);
    return list.length ? list : null;
  }
  if (typeof value === "string") {
    const list = value
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    return list.length ? list : null;
  }
  return null;
}

/**
 * The Commerce reply carries `size` (and `size_fit_note`) beside `attributes`,
 * while every detail page — and the agent's `get_product_details` mapper —
 * reads sizes from `attributes.size`. Until 2026-10-28 that mismatch left
 * the size list empty and the buy button stuck on "Select a size", although
 * the reply named nine sizes. Folded here, once, so each consumer of this
 * call sees one shape; the top-level field is left in place and an
 * `attributes.size` the backend does send wins.
 */
export function normalizeProductDetailRow(row) {
  if (!row || typeof row !== "object" || Array.isArray(row)) return row;
  const attributes =
    row.attributes && typeof row.attributes === "object" && !Array.isArray(row.attributes)
      ? row.attributes
      : {};
  if (sizeListOf(attributes.size)) return row;
  const sizes = sizeListOf(row.size);
  if (!sizes) return row;
  return { ...row, attributes: { ...attributes, size: sizes } };
}

/** `normalizeProductDetailRow` over the product, its variants and the similar products. */
export function normalizeProductDetail(data) {
  if (!data || typeof data !== "object" || Array.isArray(data)) return data;
  const mapRows = (rows) =>
    Array.isArray(rows) ? rows.map(normalizeProductDetailRow) : rows;
  return {
    ...data,
    product: normalizeProductDetailRow(data.product),
    variants: mapRows(data.variants),
    similar_products: mapRows(data.similar_products),
  };
}

export const fetchProductDetail = async (productId, customerId) => {

  if (!productId || !customerId) {
    throw new Error("Both productId and customerId are required");
  }



  const response = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",

    },
    body: JSON.stringify({
      product_id: productId,
      visitor_id: customerId,
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return normalizeProductDetail(data);
};
